// UpdatePaymentModal.js

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styles from './UpdatePaymentModal.module.css'; 
import { toast, cssTransition } from "react-toastify";
import { ToastContainer } from "react-toastify";

const UpdateRefundModal = ({ entry, onClose, onUpdate,isReadOnly  }) => {
  const [RefundTransactionID, setRefundTransactionID] = useState('');
  const [RefundDate, setRefundDate] = useState('');
  const [RefundAmount, setRefundamount] = useState('');
  // const [paymentMode, setPaymentMode] = useState(entry?.PaymentMethod || "");

  useEffect(() => {
    if (entry) {
      setRefundTransactionID(entry?.RefundDetails?.RefundTransactionID||'')
      setRefundDate(entry?.RefundDetails?.RefundDate || '');
      setRefundamount(entry?.RefundDetails?.RefundAmount|| '');
    }
  }, [entry]);

  const handlePaymentSubmit = async () => {
  
   
   
    if(RefundAmount==="" ){
      toast.error("Refund amount is mandatory");
      return;

    }

    try {
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/sales/RefundDetails`, {
        id: entry.id,
        RefundTransactionID,
        RefundDate,
        RefundAmount,
     
      });   
      alert('Refund details updated successfully!');
      onUpdate(entry.id,RefundTransactionID, RefundDate, RefundAmount);
      onClose();
    } catch (error) {
      alert('Failed to update Refund details.');
      console.error('Failed to update Refund details:', error);
    }
  };

  const submitButtonClass = RefundAmount? styles.received :  styles.pending ;
  
  return (
    
    <div className={styles['modal']}>
       <ToastContainer position="bottom-right" autoClose={5000} />
      <div className={styles['modal-content']}>
        <h2>Update Refund Details</h2>
        <hr></hr>
       
        <div>
          <label htmlFor="receivedAmount">Refund Amount:</label>
          <input
            id="receivedAmount"
            type="number"
            value={RefundAmount}
            onChange={(e) => setRefundamount(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="paymentDate">Refund Date:</label>
          <input
            id="paymentDate"
            type="date"
            value={RefundDate}
            onChange={(e) => setRefundDate(e.target.value)}
          />
        </div>
        <div>
          <label htmlFor="receivedAmount">Refund Transaction Id</label>
          <input
            id="receivedAmount"
            type="text"
            value={RefundTransactionID}
            onChange={(e) => setRefundTransactionID(e.target.value)}
          />
        </div>
        {!isReadOnly &&( <button onClick={handlePaymentSubmit} className={`${styles.submit} ${submitButtonClass}`} >Submit</button>)}
        <button onClick={onClose} className={styles['cancel']} >Cancel</button>
      </div>
    </div>
  );
};

export default UpdateRefundModal;
